<template>
  <div class="couponList" v-loading="loading">
    <template v-if="cashCouponsList.length">
      <div class="coupon-list clearfix">
        <div class="coupon-item" :class="{'fade': coupon.voucherStatus !== 'UN_CHECK'}" v-for="coupon in cashCouponsList" :key="coupon.id">
          <div class="c-type">
            <div class="c-price">
              <em>¥</em>
              <strong>{{ coupon.voucherPrice | decimal }}</strong>
            </div>
            <div class="c-limit">{{ coupon.voucherName }}</div>
            <div class="c-time">{{ coupon.voucherStartTime | formatTime('yyyy.MM.dd') }}-{{ coupon.voucherEndTime | formatTime('yyyy.MM.dd')  }}</div>
          </div>
          <div class="c-msg">
            <div class="c-range">
              <div class="range-item clearfix">
                <span class="label">券类型：</span>
                <span class="txt">代金券</span>
              </div>
              <div class="range-item clearfix">
                <span class="label">券编号：</span>
                <span class="txt">{{ coupon.userVoucherCode }}</span>
              </div>
              <div class="range-item clearfix">
                <span class="label">叠加：</span>
                <span class="txt">{{ coupon.voucherParallelFlag === 'Y' ? '可叠加使用' : '不可叠加使用' }}</span>
              </div>
              <div class="range-item clearfix">
                <span class="label">限制：</span>
                <span class="txt u-line-three">{{ coupon.voucherInfo.voucherDesc || '暂无' }}</span>
              </div>
            </div>
            <div class="c-btn" v-if="coupon.voucherStatus === 'UN_CHECK'">
              <router-link tag="div" to="/goodsList" class="btn-use">立即使用</router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="{total, pageSize, currentPage: pageNum}" @callFather="handlePageChange"></Pagination>
    </template>
    <template v-else>
      <empty>暂无代金券</empty>
    </template>
  </div>
</template>

<script type="text/ecmascript-6">
import {fetchUserCashCoupons} from "../../../api/xunyou";
import Pagination from '@/components/Pagination';
import Empty from '@/components/empty';
export default {
  name: 'couponList',
  components: {
    Pagination,
    Empty
  },
  props: {
    status: String
  },
  data() {
    return {
      loading: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      cashCouponsList: []
    }
  },
  computed: {
    userId () {
      return this.$store.getters.userId;
    }
  },
  mounted () {
    this.search();
  },
  methods: {
    // 查询
    search () {
      this.pageNum = 1;
      this.getMyCashCoupons();
    },
    // 下一页
    handlePageChange (val) {
      this.pageNum = val.currentPage;
      this.pageSize = val.pageSize;
      this.getMyCashCoupons();
    },
    // 获取代金券
    getMyCashCoupons () {
      const params = {
        muid: this.userId,
        voucherStatus: this.status,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.loading = true;
      console.log('请求参数：', params)
      fetchUserCashCoupons(params).then(res => {
        console.log('我的代金券：', res);
        this.loading = false;
        if (res.code === 0) {
          this.total = res.total;
          this.cashCouponsList = res.rows;
        }
      }).catch(err => {
        console.log('error', err)
        this.$message.error('请求失败，请稍候重试');
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.coupon-item{
  width: 277px;
  float: left;
  margin: 0 20px 20px 0;
  &.fade{
    filter: grayscale(1);
  }
  .c-type{
    position: relative;
    width: 100%;
    height: 129px;
    padding: 30px 0 0;
    overflow: hidden;
    color: #fff;
    text-align: center;
    background: linear-gradient(43deg, #ff5656, #ffa183);
    &:before{
      content: '';
      display: block;
      border-radius: 0 0 300px 300px;
      height: 10px;
      width: 30px;
      background-color: #fff;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .c-price{
      position: relative;
      margin: 0 0 5px;
      text-align: center;
      font-weight: 400;
      em{
        font-family: verdana;
        font-size: 24px;
      }
      strong{
        line-height: 45px;
        font-size: 40px;
        font-family: Arial;
      }
    }
    .c-limit{
      height: 44px;
      line-height: 22px;
      overflow: hidden;
      margin: 0 0 5px;
    }
    .c-time{
      color: #fff1ef;
    }
  }
  .c-msg{
    height: 180px;
    padding: 15px 10px;
    background: #f9f9f9;
    .range-item{
      display: inline-block;
      display: block;
      margin: 0 0 10px;
      .label{
        float: left;
        width: 60px;
        display: inline;
        text-align-last: justify;
        color: #666666;
      }
      .txt{
        float: left;
        width: 190px;
        color: #999;
        overflow: hidden;
      }
    }
    .c-btn{
      text-align: center;
      margin-top: 40px;
      .btn-use{
        display: inline-block;
        width: 100px;
        height: 30px;
        border-radius: 30px;
        border: 1px solid #ff7163;
        text-align: center;
        line-height: 30px;
        color: #ff7867;
        cursor: pointer;
        &:hover{
          background-color: rgba(255, 120,103, 0.1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myOrder/propertyCenter/couponList.vue